var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from 'react';
/**
 * A hook that enables a quick check to see if an image src will load. Useful
 * when showing an image or a fallback component depending on if the image
 * will load or not without seeing a broken image tag.
 *
 * @param src string src of the image to load
 */
export function useCanImageLoad(src) {
    var _a = __read(useState(false), 2), loaded = _a[0], setLoaded = _a[1];
    useEffect(function () {
        if (!src) {
            setLoaded(false);
            return undefined;
        }
        setLoaded('loading');
        var active = true;
        var image = new Image();
        image.src = src;
        image.onload = function () {
            if (!active)
                return;
            setLoaded('loaded');
        };
        image.onerror = function () {
            if (!active)
                return;
            setLoaded('error');
        };
        return function () {
            active = false;
        };
    }, [src]);
    return loaded;
}
useCanImageLoad.displayName = 'useCanImageLoad';
